import {
  Backdrop,
  Box,
  Button,
  Chip,
  CircularProgress,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomSnackbar from "../../components/ui-component/snackbar/CustomSnackbar";
import { useNavigate } from "react-router-dom";
import { fDate } from "../../../utils/formatTime";
import { useGetTokenOrLogout } from "../../../utils/token";
import HeadingCard from "../../newComponent/NewCardsComp/HeadingCard";
import MainCard from "../../../components/Maincard";
import CustomNoRowsOverlay from "../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import { DataGrid } from "@mui/x-data-grid";
import VeiwIcon from "../../newComponent/iconsComp/VeiwIcon";
import DenyIcon from "../../newComponent/iconsComp/DenyIcon";
import ApproveIcon from "../../newComponent/iconsComp/ApproveIcon";
import SearchTextFieldComp from "../../newComponent/newtextfieldComp/SearchTextFieldComp";
import CustomPopup from "../../../components/CustomPopup";
import FilterButtonComponent from "../../newComponent/NewButtonComp/FilterButtonComponent";
import CashCollectionFilter from "../payments/CashCollectionFilter";
import StudentLeaveRequestFilter from "./StudentLeaveRequestFilter";
import ConfirmationPopup from "../../../components/ConfirmationPopup";
import LoaderComp from "../../newComponent/LoaderComp/Loader";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

function StudentLeaveRequests() {
  const navigate = useNavigate();
  const getTokenOrLogout = useGetTokenOrLogout();

  const userId = localStorage.getItem("userId");
  const [isLoading, setIsLoading] = useState(false);
  const [leaveRequests, setLeaveRequests] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [searchData, setSearchData] =useState([])
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [open, setOpen] = useState(false);
  const [openApprovePopup, setOpenApprovePopup] = useState(false);
  const [openDeniedPopup, setOpenDeniedPopup] = useState(false);
  const [leaveId, setLeaveId] = useState(null);
  const [newStatus, setNewStatus] = useState(null);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleUpdateStatus = () => {
    // Update the status locally in the state
    const updatedPayments = leaveRequests.map((leave) =>
      leave.id === leaveId ? { ...leave, status: newStatus } : leave
    );
    setLeaveRequests(updatedPayments);

    // Send a request to the server to update the status
    fetch(`${API_ENDPOINT}route2.0/updateleaverequest/${leaveId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        status: newStatus,
        user_id: parseInt(userId),
      }),
    })
      .then((response) => {
        if (response.ok) {
          showSnackbar("Leave status updated successfully", "success");
          setTimeout(() => {
            window.location.reload();
          }, 1000);
          // Remove the row from state if the status is updated successfully
          // const updatedPayments = leaveRequests.filter(payment => payment.id !== leaveId);
          // setLeaveRequests(updatedPayments);
        } else {
          showSnackbar("Failed to update leave status", "error");
          throw new Error("Failed to update leave status");
        }
        // Handle successful response if needed
      })
      .catch((error) => {
        console.error("Error updating leave status:", error);
        showSnackbar("Error updating leave status", "error");
        // Revert the status locally if the server update fails
        setLeaveRequests(leaveRequests);
      });
  };

  useEffect(() => {
    setIsLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}route2.0/showleaverequest/${userId}`,
          { headers }
        );
        if (response.ok) {
          const data = await response.json();

          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setLeaveRequests(sortedData);
          setOriginalData(sortedData);
          setSearchData(sortedData)
          setIsLoading(false);
        } else if (response.status === 404) {
          navigate("/page404");
        } else if (response.status === 401) {
          navigate("/page401");
        } else if (response.status === 403) {
          navigate("/page403");
        } else if (response.status === 440) {
          navigate("/page440");
        } else {
          navigate("/page500");
        }
      } catch {
        navigate("/page500");
      }
    };

    fetchData();
  }, [userId]);

  const columns = [
    {
      field: "action",
      headerName: "Action",
      width: 100,
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      headerClassName: "header-cell",
      renderCell: (params) => (
        <div>
          {params?.row?.status === "Pending" && params?.row?.trainer_id?.user_id===parseInt(userId) && (
            <Box display="flex" gap={1}>
              <ApproveIcon
                tooltipTitle="Approve Request"
                // onClick={() => handleUpdateStatus(params?.row.id, "Approved")}
                onClick={() =>
                  handleOpenApprovePopup(params?.row.id, "Approved")
                }
              />

              <DenyIcon
                tooltipTitle="deny Request"
                onClick={() => handleOpenDeniedPopup(params?.row.id, "Denied")}
              />
            </Box>
          )}
        </div>
      ),
    },
    {
      field: "enquiry_name",
      headerName: "Enquiry Name",
      width: 150,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `  ${
          params?.row.student_class_details_id.enquiry_id?.first_name || " "
        }  ${params?.row.student_class_details_id.enquiry_id?.last_name || ""}`,
      renderCell: (params) => (
        <div>
          {params?.row.student_class_details_id.enquiry_id?.first_name}{" "}
          {params?.row.student_class_details_id.enquiry_id?.last_name}
        </div>
      ),
    },
    {
      field: "mobile",
      headerName: "Mobile",
      width: 100,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `  ${params?.row.student_class_details_id.enquiry_id?.mobile || " "} `,
      renderCell: (params) => (
        <div>{params?.row.student_class_details_id.enquiry_id?.mobile} </div>
      ),
    },
    {
      field: "class",
      headerName: "Class Details",
      width: 150,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `  ${params?.row.student_class_details_id?.class_id?.name || " "} `,
      renderCell: (params) => (
        <div>{params?.row.student_class_details_id?.class_id?.name} </div>
      ),
    },
    {
      field: "trainer_id",
      headerName: "Trainer",
      width: 150,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `  ${params?.row.trainer_id?.first_name|| " "} ${params?.row.trainer_id?.last_name|| " "}`,
      renderCell: (params) => (
        <div>{params?.row.trainer_id?.first_name}  {params?.row.trainer_id?.last_name}</div>
      ),
    },
    {
      field: "branch",
      headerName: "Enrolled Branch",
      width: 100,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `  ${
          params?.row.student_class_details_id?.branch_id?.branch_name || " "
        } `,
      renderCell: (params) => (
        <div>
          {params?.row.student_class_details_id?.branch_id?.branch_name}{" "}
        </div>
      ),
    },

    {
      field: "no_of_days",
      headerName: "Number of Days",
      width: 100,
      minWidth: 150,
      headerClassName: "header-cell",
    },
    {
      field: "start_date",
      headerName: "Leave From Date",
      width: 100,
      minWidth: 150,
      headerClassName: "header-cell",
      renderCell: (params) => <div>{fDate(params?.row?.start_date)} </div>,
    },
    {
      field: "end_date",
      headerName: "Leave To Date",
      width: 100,
      minWidth: 150,
      headerClassName: "header-cell",
      renderCell: (params) => <div>{fDate(params?.row?.end_date)} </div>,
    },
    {
      field: "created_date",
      headerName: "Request Date",
      width: 100,
      minWidth: 150,
      headerClassName: "header-cell",
      renderCell: (params) => <div>{fDate(params?.row?.created_date)} </div>,
    },
    {
      field: "status",
      headerName: "Status",
      width: 100,
      minWidth: 150,
      headerClassName: "header-cell",
      renderCell: (params) => (
        <div>
          {" "}
          {params?.row?.status === "Approved" && (
            <Chip
              variant="contained"
              size="small"
              label="Approved"
              color="secondary"
            />
          )}
          {params?.row?.status === "Denied" && (
            <Chip
              variant="contained"
              size="small"
              label="Denied"
              color="primary"
            />
          )}
          {params?.row?.status === "Pending" && (
            <Chip
              variant="contained"
              size="small"
              label="Pending"
              color="warning"
            />
          )}
          {params?.row?.status === "Cancelled" && (
            <Chip
              variant="contained"
              size="small"
              label="Cancelled"
              color="error"
            />
          )}{" "}
        </div>
      ),
    },
    {
      field: "approve_by",
      headerName: "Approved/Denied By",
      width: 100,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `  ${params?.row.approved_by?.first_name || " "}  ${
          params?.row.approved_by?.last_name || ""
        }`,
      renderCell: (params) => (
        <div>
          {params?.row.approved_by?.first_name}{" "}
          {params?.row.approved_by?.last_name}
        </div>
      ),
    },
  ];

  // Search by all table column

  const handleSearchByName = (e) => {
    const value = e.target.value.toLowerCase().replace(/\s+/g, ""); // Normalize search value (lowercase and remove spaces)

    let filteredData1 = searchData.filter((data) => {
      // Check each field for a match with the search value
      const fieldsToSearch = [
        `${data?.student_class_details_id?.enquiry_id?.first_name || ""} ${
          data?.student_class_details_id?.enquiry_id?.last_name || ""
        }`,

         `${data?.student_class_details_id?.enquiry_id?.mobile || ""}` ,
         
        
`${data?.trainer_id?.first_name || ""} ${
          data?.trainer_id?.last_name || ""
        }`,

    
        `${data?.student_class_details_id?.class_id?.name || ""}`,
        `${data?.student_class_details_id?.branch_id?.branch_name || ""}`,
        `${data?.no_of_days || ""}`,
        `${data?.end_date || ""}`,
        `${data?.start_date || ""}`,
        `${data?.start_date || ""}`,
        `${fDate(data?.created_date || "")}`,
        `  ${data?.approved_by?.first_name || " "}  ${
          data.approved_by?.last_name || ""
        }`,
        `${data?.status}`,
      ];

      // Check if any of the fields contain the search value
      return fieldsToSearch.some((field) =>
        field.toLowerCase().replace(/\s+/g, "").includes(value)
      );
    });

    setLeaveRequests(filteredData1); // Update the filtered data
  };

  const handleToggle = () => {
    setOpen(!open);
  };

  const handleOpenApprovePopup = (leaveId, newStatus) => {
    setOpenApprovePopup(true);
    setLeaveId(leaveId);
    setNewStatus(newStatus);
  };

  const handleCloseApprovePopup = () => {
    setOpenApprovePopup(false);
  };

  const handleOpenDeniedPopup = (leaveId, newStatus) => {
    setOpenDeniedPopup(true);
    setLeaveId(leaveId);
    setNewStatus(newStatus);
  };

  const handleCloseDeniedPopup = () => {
    setOpenDeniedPopup(false);
  };
  return (
    <>
      <LoaderComp isLoading={isLoading} />
     

      <Grid container spacing={2} mb={2}>
        <Grid item xs={12} lg={3} sm={5} md={4}>
          <HeadingCard label="Student Leave Requests" />
        </Grid>
        <Grid item xs={12} lg={9} sm={7} md={8} textAlign="end">
          {" "}
          <FilterButtonComponent
            title="Filter"
            onClick={handleToggle}
            open={open}
            showendIcon={true}
          />
        </Grid>

        <Grid item xs={12} lg={12} sm={12} md={12}>
          <StudentLeaveRequestFilter
            open={open}
            setOpen={setOpen}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            setLeaveRequests={setLeaveRequests}
            setSearchData={setSearchData}
            showSnackbar={showSnackbar}
            originalData={originalData}
          />
        </Grid>

        <Grid item xs={12}>
          <MainCard>
            <Grid container spacing={2}>
              <Grid item xs={12} textAlign="end">
                <SearchTextFieldComp onChange={handleSearchByName} />
              </Grid>
              <Grid item xs={12}>
                <DataGrid
                  rows={leaveRequests}
                  columns={columns}
                  slots={{
                    noRowsOverlay: CustomNoRowsOverlay,
                  }}
                  autoHeight
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 25,
                      },
                    },
                  }}
                  pageSizeOptions={[25, 50, 100]}
                />
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
      </Grid>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />

      <ConfirmationPopup
        open={openApprovePopup}
        maxWidth="xs"
        onClose={handleCloseApprovePopup}
        textBody="Are you sure you want to approve this leave request?"
        approveButton="Approve Leave"
        cancelButton="Cancel"
        handleUpdateStatus={handleUpdateStatus}
      />

      <ConfirmationPopup
        open={openDeniedPopup}
        maxWidth="xs"
        onClose={handleCloseDeniedPopup}
        textBody="Are you sure you want to denied this leave request?"
        approveButton="Denied Leave"
        cancelButton="Cancel"
        handleUpdateStatus={handleUpdateStatus}
      />
    </>
  );
}

export default StudentLeaveRequests;
